
  export default {
    mounted() {
      // The root layout's head script reads the same key before the first paint.
      const KEY = "nav-rail-expanded";
      const root = document.documentElement;
      const expanded = () => root.dataset.railExpanded !== "false";
      const set = (v) => {
        root.dataset.railExpanded = v;
        localStorage.setItem(KEY, v);
      };
      this.el.querySelectorAll("[data-rail-toggle]").forEach((btn) => {
        btn.addEventListener("click", () => set(!expanded()));
      });
      this.el.querySelectorAll("[data-group-toggle]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const group = btn.closest("[data-group]");
          if (group) group.dataset.open = String(group.dataset.open !== "true");
        });
      });
      this._onRailClick = (event) => {
        if (expanded()) return;
        if (event.target.closest("a, button, [role=menuitem], [data-no-expand]")) return;
        set(true);
      };
      this.el.addEventListener("click", this._onRailClick);
      this.markActive();
      this._onNav = () => this.markActive();
      window.addEventListener("phx:page-loading-stop", this._onNav);
    },
    destroyed() {
      this.el.removeEventListener("click", this._onRailClick);
      window.removeEventListener("phx:page-loading-stop", this._onNav);
    },
    markActive() {
      const path = window.location.pathname;
      const navs = Array.from(this.el.querySelectorAll("[data-nav]"));
      let best = null, bestLen = -1;
      for (const el of navs) {
        el.dataset.active = "false";
        for (const m of (el.dataset.match || "").split(" ").filter(Boolean)) {
          if ((path === m || path.startsWith(m + "/")) && m.length > bestLen) { bestLen = m.length; best = el; }
        }
      }
      if (best) best.dataset.active = "true";
      this.el.querySelectorAll("[data-group]").forEach((g) => {
        const gm = (g.dataset.groupMatch || "").split(" ").filter(Boolean);
        if (gm.some((m) => path === m || path.startsWith(m + "/"))) g.dataset.open = "true";
      });
    }
  }
